import {
  LOAD_INITIAL_STATE,
  MANDATORY,
  PurchaseOrderActions,
  SET,
  SET_PURCHASE_ORDER_ASYNC_ERRORS,
  SET_VALID_PO_MASKS,
  VALIDATE_END,
  VALIDATE_START,
  VALIDATION_ENDED,
  RESET_MASKS_FETCH,
} from '../../actions/purchase-order-actions/purchase-order.actions';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { ValidatorFn } from '@angular/forms';
import {
  PurchaseOrderAsyncErrors,
} from '@ordersnproducts/modules/order-builder/modules/location/models/purchase-order-async-errors';

export interface IPurchaseOrderState {
  fetching: boolean;
  selected: string;
  required: boolean;
  disabled: boolean;
  visible: boolean;
  validators: ValidatorFn[];
  validating: boolean;
  validationEnded: boolean;
  errors: PurchaseOrderAsyncErrors;
  validMasks?: string[];
}

export const initialState: IPurchaseOrderState = {
  fetching: undefined,
  selected: '',
  required: false,
  disabled: false,
  visible: false,
  validators: [],
  validating: false,
  validationEnded: false,
  errors: null,
  validMasks: undefined,
};

export function purchaseOrderReducer(state = initialState, action: PurchaseOrderActions): IPurchaseOrderState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const purchaseOrderConfig: ILocationConfigUnit = action.payload as ILocationConfigUnit;
        return {
          ...state,
          disabled: purchaseOrderConfig.disabled,
          required: purchaseOrderConfig.required,
          visible: purchaseOrderConfig.visible,
          validators: purchaseOrderConfig.validators,
        } as IPurchaseOrderState;
      } else {
        return {
          ...initialState,
        };
      }
    }
    case MANDATORY: {
      return {
        ...state,
        fetching: true,
        disabled: false,
        required: action.payload,
        errors: null,
      } as IPurchaseOrderState;
    }
    case SET: {
      return {
        ...state,
        selected: action.payload,
      } as IPurchaseOrderState;
    }
    case VALIDATE_START: {
      return {
        ...state,
        validating: true,
        validationEnded: false,
      } as IPurchaseOrderState;
    }
    case VALIDATE_END: {
      return {
        ...state,
        validating: false,
      } as IPurchaseOrderState;
    }
    case VALIDATION_ENDED: {
      return {
        ...state,
        validationEnded: true,
      } as IPurchaseOrderState;
    }
    case SET_PURCHASE_ORDER_ASYNC_ERRORS: {
      return {
        ...state,
        errors: action.payload as PurchaseOrderAsyncErrors,
      };
    }
    case SET_VALID_PO_MASKS: {
      return {
        ...state,
        validMasks: action.payload,
        fetching: false,
      };
    }
    case RESET_MASKS_FETCH: {
      return {
        ...state,
        fetching: undefined,
      };
    }
    default: {
      return state;
    }
  }
}
